import _ from "underscore";
import {ComboGroup} from '../groups/comboGroup'
import {CellItem} from './cellItem'
import {OptionItem} from '../options'
import {ValidateResult} from '../contentType'
import {XmlTagInfo} from "../xmlTagProvider";
import {comboItemView} from "../../ui/items/combo";
import {Vnode} from "mithril";

export class ComboItem extends CellItem {

    static fromXml(config: XmlTagInfo){
        return new ComboItem(config);
    }

    getView():Vnode {
        return comboItemView(this);
    }

    getOptions() : OptionItem [] {
        const group = this.getGroup();
        const list = this.form.questionary.options!.getList(group.optionsId); // I hope is set at this moment // TODO check

        return this.getVariable() ?
            list.filter(i => !!i.value) :
            list;
    }

    getGroup() {
        return <ComboGroup>this.group;
    }

    set(value:any){
        if(this.cell.enabled) {
            this.setVariable(value);
            this.updateUnknowns();
            this.form.reValidate();
        }
    }

    getSelectedOption(): OptionItem {
        return _.find(this.getOptions(), o => o.value === '' + this.getVariable());
    }

    active(){
        return this.getVariable() !== null && this.getVariable() !== undefined;
    }

    validate (){
        return new ValidateResult(this.active(), []);
    }

    empty(){
        return this.getVariable() === null;
    }
}
